var map = {
	"./Childrenarea_6_fullsize.jpg": 1161,
	"./E_block_8_fullsize.jpg": 1260,
	"./Gateview_1_fullsize.jpg": 1980,
	"./H_block_7_fullsize.jpg": 2326,
	"./Jblock_10_fullsize.jpg": 7424,
	"./Layout_fullsize.jpg": 4220,
	"./Premangan_9_fullsize.jpg": 805,
	"./Shivangan_3_fullsize.jpg": 2715,
	"./Swimmingpool_5_fullsize.jpg": 293,
	"./Templeview_2_fullsize.jpg": 2499,
	"./Tulsiangan_4_fullsize.jpg": 3849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9369;